export interface SalesInfo {
	ccAndeWalletQty: number;
	ccAndeWalletAmount: number;
	cashAndChecksQty: number;
	cashAndChecksAmount: number;
	poQty: number;
	poAmount: number;
	sdQty: number;
	sdAmount: number;
	sdCashEquivalentQty: number;
	sdCashEquivalentAmount: number;
	totalQty: number;
	totalAmount: number;
	taxExemptSales: number;
	taxableSales: number;
	grossTotal: number;
	taxTotal: number;
	taxableSalesLessTax: number;
	taxRate: number;
	stfRedeemed: number;
}

export const defaultSalesInfo: SalesInfo = {
	ccAndeWalletQty: 0,
	ccAndeWalletAmount: 0,
	cashAndChecksQty: 0,
	cashAndChecksAmount: 0,
	poQty: 0,
	poAmount: 0,
	sdQty: 0,
	sdAmount: 0,
	sdCashEquivalentQty: 0,
	sdCashEquivalentAmount: 0,
	totalQty: 0,
	totalAmount: 0,
	taxExemptSales: 0,
	taxableSales: 0,
	grossTotal: 0,
	taxTotal: 0,
	taxableSalesLessTax: 0,
	taxRate: 0,
	stfRedeemed: 0,
};
